import { render, staticRenderFns } from "./route-detail.vue?vue&type=template&id=6e231dcb&"
import script from "./route-detail.vue?vue&type=script&lang=ts&"
export * from "./route-detail.vue?vue&type=script&lang=ts&"
import style0 from "./route-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports